const $       = require('jquery');
const tpl     = require('../util/template');
const eventer = require('../util/eventer');
const Modal   = require('./modal');

function BasicModal(opts) {
  let content = $(`
    <div class="basic-modal wrfont">
      <div class="modal-title">
        <h3>${opts.title}</h3>
      </div>
      <div class="modal-content"></div>
      <div class="modal-buttons"></div>
    </div>
  `);

  opts.buttons.forEach((opts, idx) => {
    const btn = opts.elem || $(`
      <button
        class="${tpl.cls({
          'action-btn': true,
          'primary': opts.primary
        })}">
        ${opts.text}
      </button>
    `);

    if (opts.handler) btn.click(opts.handler);

    btn.appendTo(content.find('.modal-buttons'));
  });

  content.find('.modal-content').append(opts.content);

  if (opts.align_buttons) {
    content.find('.modal-buttons').attr('align', opts.align_buttons);
  }

  return Modal({ content: content, no_close: opts.no_close });
}

module.exports = BasicModal;
